import { Rewards } from '@arrived/models';

import { rewardsApi } from '../api';

export const getPromotion = async (promotionUuid: string) => {
  const response = await rewardsApi.get<Rewards.Promotion>(`/promotions/${promotionUuid}`);
  return response.data;
};

export const getPromotions = async (filters?: Rewards.PromotionFilters) => {
  const response = await rewardsApi.get<Rewards.PromotionSearchResult>(`/promotions`, { params: filters });
  return response.data;
};

export const getPromotionUsage = async (promotionUuid: string) => {
  const response = await rewardsApi.get<Rewards.PromotionUsage>(`/promotions/${promotionUuid}/usage`);
  return response.data;
};

export const getPromotionCodes = async (promotionUuid: string) => {
  const response = await rewardsApi.get<Rewards.PromotionCodesSearchResponse>(`/promotions/${promotionUuid}/codes`);
  return response.data;
};

export const putPromotion = async (promotionUuid: string, promotionBody: Rewards.PromotionUpdateRequest) => {
  const response = await rewardsApi.put<Rewards.Promotion>(`/promotions/${promotionUuid}`, promotionBody);
  return response.data;
};

export const postPromotion = async (promotionBody: Rewards.PromotionCreationRequest) => {
  const response = await rewardsApi.post<Rewards.Promotion>(`/promotions`, promotionBody);
  return response.data;
};
